import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import { useContent } from "../lib/content";

export default function Layout({ children }) {
  const { loaded } = useContent();

  if (!loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center grain-bg">
        <div className="w-10 h-10 border-4 border-amber-300 border-t-amber-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col grain-bg">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
